import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {Mutation} from 'react-apollo';
import gql from 'graphql-tag';
import StripePaymentConfirmation, {parentPropTypes} from './StripePaymentConfirmation';
import {Elements} from 'react-stripe-elements';

const GRAPHQL_MUTATION_BILLING_SUBSCRIBE = gql`
  mutation billingSubscribe($userId: ID!, $plan: BillingSubscriptionPlanInput!) {
    billingSubscribe(userId: $userId, plan: $plan) {
      id
      latestInvoice {
        id
        hostedInvoiceUrl
        paymentIntent {
          id
          status
          clientSecret
        }
      }
    }
  }
`;

const AddSubscription = ({t, userId, subscriptionId, ...stripeMutationProps}) => (
  <Mutation
    mutation={GRAPHQL_MUTATION_BILLING_SUBSCRIBE}
    variables={{userId, plan: {id: subscriptionId}}}
    refetchQueries={['refreshToken']}
  >
    {(mutation) => (
      <Elements>
        <StripePaymentConfirmation
          mutation={mutation}
          extractInvoice={data => data.billingSubscribe.latestInvoice}
          confirmBtnText={t('subscribe')}
          {...stripeMutationProps}
        />
      </Elements>
    )}
  </Mutation>
);

AddSubscription.propTypes = {
  t: PropTypes.func.isRequired,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  subscriptionId: PropTypes.string.isRequired,
  ...parentPropTypes,
};

export default compose(
  withTranslation('stripe'),
)(AddSubscription);
